import TitleBar from "../components/TitleBar";

export default function Certifications() {
  return (
    <>
      <TitleBar />
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              Certification Tracks
            </h1>
            <p className="my-2">
              The EVTCC Certification Program has four technician certification
              tracks and a management track. The technician certification tracks
              are for fire apparatus, ambulance, law enforcement, and airport
              rescue and fire fighting (ARFF) vehicle technicians. Technicians
              have two options of becoming EVT Certified.
            </p>
            <ul className="my-2 ml-6 list-disc">
              <li>
                Option 1: Technicians can become certified in the specific test
                area(s) by taking only the EVT exams. Each EVTCC test passed is a standalone credential in its own right. For a more comprehensive professional qualification, you may consider certifying in EVTCC levels, explained in Option 2.
              </li>
              <li>
                Option 2: Technicians can attain the highest EVTCC certification
                status by combining EVT and ASE exams to reach Level I, II and
                Master EVT Certification.
              </li>
            </ul>
            <p className="my-2">
              Please note that the Law Enforcement Vechicle (LEV) Certification
              Track has only one exam and only one Level. The Management Track
              has a Level I and Level II exam and does not require any ASE
              exams. The Level Certification Tracks are explained below.
            </p>
            <p className="my-2">
              <a
                className="text-(--themered) hover:text-(--darkred) hover:underline"
                href="/downloads/EVTCC-Level-Application-Form.pdf"
              >
                Download the level application form
              </a>
            </p>
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              Jump to a section
            </h2>
            <ul className="my-2 ml-6 list-disc">
              <li>
                <a
                  href="#fire"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Fire Apparatus Technician Certification Track
                </a>
              </li>
              <li>
                <a
                  href="#ambulance"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Ambulance Technician Certification Track
                </a>
              </li>
              <li>
                <a
                  href="#arff"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  ARFF Technician Certification Track
                </a>
              </li>
              <li>
                <a
                  href="#lev"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  LEV Technician Certification Track
                </a>
              </li>
              <li>
                <a
                  href="#mgmt"
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                >
                  Management Certification Track
                </a>
              </li>
            </ul>
          </section>

          <section className="mt-6" id="fire">
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              Fire Apparatus Technician Certification Track
            </h2>
            <p className="my-2">
              The Fire Apparatus Technician Certification Track is for those
              technicians who service and maintain fire department pumpers,
              squads, aerial devices, tankers, wildland apparatus, etc. The Fire
              Apparatus Track exams cover the design and performance standards,
              specialized systems and equipment, and accepted practices used in
              the service and maintenance of fire apparatus. This track has
              three levels of certification. Each level requires specific EVT
              exams and ASE heavy-duty truck exams. See below for the
              requirements for each level.
            </p>
            <div className="my-2 mt-4 grid gap-4 md:grid-cols-3">
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level I
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>
                    F1 &ndash; Maintenance, Inspection, and Testing of Fire
                    Apparatus
                  </li>
                  <li>
                    F2 &ndash; Design &amp; Performance Standards of Fire
                    Apparatus
                  </li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T4 &ndash; Truck &ndash; Brakes</li>
                  <li>T5 &ndash; Truck &ndash; Suspension &amp; Steering</li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level II
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>F3 &ndash; Fire Pumps &amp; Accessories</li>
                  <li>F4 &ndash; Fire Apparatus Electrical Systems</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T2 &ndash; Truck &ndash; Diesel Engines</li>
                  <li>T3 &ndash; Truck &ndash; Drive Train</li>
                  <li>
                    T6 &ndash; Truck &ndash; Electrical / Electronic Systems
                  </li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level III (Master)
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>F5 &ndash; Aerial Fire Apparatus</li>
                  <li>F6 &ndash; Allison Automatic Transmissions</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T1 &ndash; Truck &ndash; Gasoline Engines</li>
                  <li>
                    T7 &ndash; Truck &ndash; Heating, Ventilation &amp; Air
                    Conditioning (HVAC)
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-6" id="ambulance">
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              Ambulance Technician Certification Track
            </h2>
            <p className="my-2">
              The Ambulance Technician Certification Track recognizes
              technicians who have gained specialization in ambulances. The
              requirements for track include EVTCC exams about electrical,
              mechanical, and HVAC aspects of ambulance maintenance, plus
              relevant ASE automotive and truck exams. This track has three
              levels of certification. See below for the requirements for each
              level.
            </p>
            <div className="my-2 mt-4 grid gap-4 md:grid-cols-3">
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level I
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>
                    E0 &ndash; Maintenance, Inspection, and Testing of
                    Ambulances
                  </li>
                  <li>E1 &ndash; Design &amp; Performance of Ambulances</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>A4 &ndash; Auto &ndash; Suspension &amp; Steering</li>
                  <li>A5 &ndash; Auto &ndash; Brakes</li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level II
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>E2 &ndash; Ambulance Electrical Systems</li>
                  <li>
                    E3 &ndash; Ambulance Heating, Air-Conditioning &amp;
                    Ventilation
                  </li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>A9 &ndash; Auto &ndash; Light Vehicle Diesel Engines</li>
                  <li>T3 &ndash; Truck &ndash; Drive Train</li>
                  <li>T4 &ndash; Truck &ndash; Brakes</li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level III (Master)
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>E4 &ndash; Ambulance Cab, Chassis and Powertrain</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T1 &ndash; Truck &ndash; Gasoline Engines</li>
                  <li>T2 &ndash; Truck &ndash; Diesel Engines</li>
                  <li>T5 &ndash; Truck &ndash; Suspension &amp; Steering</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-6" id="arff">
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              ARFF Technician Certification Track
            </h2>
            <p className="my-2">
              The ARFF Technician Certification track program recognizes
              technicians who work on airport rescue and fire-fighting vehicles.
              The exams cover design and performance standards, preventive
              maintenance, chassis and vehicle performance, and the
              extinguishment systems of ARFF vehicles. This track has three
              levels of certification. Each level requires specific EVTCC exams
              and ASE exams. See below for specifics.
            </p>
            <div className="my-2 mt-4 grid gap-4 md:grid-cols-3">
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level I
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>A1 &ndash; Design &amp; Performance of ARFF Vehicles</li>
                  <li>
                    F1 &ndash; Maintenance, Inspection, and Testing of Fire
                    Apparatus
                  </li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T2 &ndash; Truck &ndash; Diesel Engines</li>
                  <li>T4 &ndash; Truck &ndash; Brakes</li>
                  <li>
                    T6 &ndash; Truck &ndash; Electrical / Electronic Systems
                  </li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level II
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>
                    A2 &ndash; Chassis &amp; Vehicle Components of ARFF Vehicles
                  </li>
                  <li>F4 &ndash; Fire Apparatus Electrical Systems</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>T3 &ndash; Truck &ndash; Drive Train</li>
                  <li>T5 &ndash; Truck &ndash; Suspension &amp; Steering</li>
                  <li>
                    T7 &ndash; Truck &ndash; Heating, Ventilation & Air
                    Conditioning (HVAC)
                  </li>
                </ul>
              </div>
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level III (Master)
                </h3>
                <h4 className="my-2 font-serif font-bold italic">
                  EVTCC Exams
                </h4>
                <ul className="ml-6 list-disc">
                  <li>
                    A3 &ndash; Water/Foam and Ancillary Extinguishment Systems
                  </li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>
                    L2 &ndash; Electronic Diesel Engine Diagnosis Specialist
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-6" id="lev">
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              LEV Technician Certification Track
            </h2>
            <p className="my-2">
              The Law Enforcement Technician Certification track program
              recognizes technicians who work on law enforcement vehicles. This
              track has one level of certification and requires specific EVT
              exams and ASE automotive exams. The exam covers specialized
              equipment installation. See below for specifics.
            </p>
            <div className="my-2 mt-4 inline-block">
              <div className="rounded-md border-2 border-black bg-gray-100 pb-4 pl-4 pr-4 pt-2">
                <h3 className="my-2 font-serif text-xl font-bold italic">
                  Level I
                </h3>
                <h4 className="my-2 font-serif font-bold italic">EVTCC Exam</h4>
                <ul className="ml-6 list-disc">
                  <li>L1 &ndash; Law Enforcement Vehicle Installation</li>
                </ul>
                <h4 className="my-2 font-serif font-bold italic">ASE Exams</h4>
                <ul className="ml-6 list-disc">
                  <li>A1 &ndash; Auto &ndash; Engine Repair</li>
                  <li>A4 &ndash; Auto &ndash; Suspension &amp; Steering</li>
                  <li>A5 &ndash; Auto &ndash; Brakes</li>
                  <li>
                    A6 &ndash; Auto &ndash; Electrical / Electronic Systems
                  </li>
                  <li>
                    A7 &ndash; Auto &ndash; Heating &amp; Air Conditioning
                  </li>
                  <li>A8 &ndash; Auto &ndash; Engine Performance</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-6" id="mgmt">
            <h2 className="my-2 mt-6 font-serif text-2xl font-bold italic text-(--darkred)">
              Management Track
            </h2>
            <p className="my-2">
              The Management certification track has a Management Level I exam for shop foremen and Level II for shop supervisors. There are no additional requirements such as other EVTCC or ASE exams.
            </p>
          </section>
        </div>
      </main>
    </>
  );
}
